<template>
	<PopupRouterViewDetail label="Bill Of Process Detail" @hideMethod="onHidden" :isShowCopyData="false">

		<!-- APP_DETAIL_HEADER -->

		<b-card header="Bill Of Process" class="mb-3 card-max-width">
			<b-row>
				<b-col cols="12" lg="6">
					<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Bill Of Process Number"
						:model="model.billOfProcessNumber" />
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id"
						label-cols-lg="12" label="Part Number" id="fieldset-part-number" size="sm"
						:model.sync="model.partNumberId" :isRequired="true" :state="validateState('partNumberId')"
						:errorMessage="getErrorMessage(errorMessage.partNumberId, 'partNumberId')"
						:selected="model.partNumber != null ? model.partNumber.partNumber : ''" @input="getParts"
						@change="updateData" :isEditable="false" :isSelectMethodExists="true"
						@onSelectMethod="setSelectedPartNumber" />
					<app-label label-cols-lg="12" size="sm" label="Part Name"
						:model="(model.partNumber != null) ? model.partNumber.partName : null" />
					<app-input-combobox-autocomplete :options="nextProcesss" optionsLabel="name" optionsKey="id"
						label-cols-lg="12" label="NextProcess" id="fieldset-next-process" size="sm"
						:model.sync="model.nextProcessId"
						:selected="model.nextProcess != null ? model.nextProcess.name : ''" @input="getNextProcesss"
						@change="updateData" :isEditable="false" :isSelectMethodExists="true"
						@onSelectMethod="setSelectedNextProcess" />
				</b-col>
				<b-col cols="12" lg="6">
					<app-label label-cols-lg="12" size="sm" label="Part Separate"
						:model="(partSeparate != null) ? partSeparate : null" />
					<app-label label-cols-lg="12" size="sm" label="Part Name Separate"
						:model="(partNameSeparate != null) ? partNameSeparate : null" />
				</b-col>

			</b-row>
		</b-card>

		<app-table-input-popup title="Bill Of Process Detail" :bordered="true" :items="billOfProcessDetails"
			:fields="fieldsBillOfProcessDetail" :busy="isDataLoading" :sort-by.sync="sortByBillOfProcessDetail"
			:sort-desc.sync="sortDescBillOfProcessDetail" small responsive
			@editButtonMethod="editRowDataBillOfProcessDetail" @deleteButtonMethod="deleteRowDataBillOfProcessDetail"
			@showPopupAddMethod="resetDataBillOfProcessDetail()"
			@showPopupUploadMethod="showPopupUploadBillOfProcessDetail()" @downloadMethod="downloadBillOfProcessDetail()"
			@addFromClipboardMethod="addFromClipboardBillOfProcessDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardBillOfProcessDetail()" :showActionButton="false"
			:showEditButton="true" :showDeleteButton="true" :showAddButton="false" :showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false" :showUploadButton="false" :showDownloadButton="false"
			:isDownloadBusy="isDownloadBillOfProcessDetail">
			<template #top-row v-if="isShowBillOfProcessDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Sequence">
					<b-form-input id="input-sequence-table" v-model="filterBillOfProcessDetail.sequence"
						size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Machine">
					<v-select append-to-body label="code" :options="machines" :value="filterBillOfProcessDetail.machineId"
						:reduce="item => item.id" v-model="filterBillOfProcessDetail.machineId" @search="getMachines"
						:filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Sub Process">
					<v-select append-to-body label="code" :options="subprocesss"
						:value="filterBillOfProcessDetail.subProcessId" :reduce="item => item.id"
						v-model="filterBillOfProcessDetail.subProcessId" @search="getSubprocesss"
						:filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Dies / Jig">
					<b-form-input id="input-dies-or-jig-number-table" v-model="filterBillOfProcessDetail.diesOrJigNumber"
						size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Sub Process Number">
					<b-form-input id="input-sub-process-number-table" v-model="filterBillOfProcessDetail.subProcessNumber"
						size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + (billOfProcessDetailPageSize * (currentBillOfProcessDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(sequence)="row">
				<app-input-textbox :id="'input-bill-of-process-detail-sequence-' + row.index" label-cols-lg="12"
					label="Sequence" size="sm" :model.sync="row.item.sequence" :state="validateState('sequence')"
					:errorMessage="getErrorMessage(errorMessage.sequence, 'sequence')"
					@change="saveInputBillOfProcessDetail(row.item)" :isEditable="false" :nolabel="true" />
			</template>
			<template v-slot:cell(machine)="row">
				<app-input-combobox-autocomplete :options="machines" optionsLabel="code" optionsKey="id"
					:id="'input-bill-of-process-detail-machine-' + row.index" label-cols-lg="12" label="Machine" size="sm"
					:model.sync="row.item.machineId" @change="saveInputBillOfProcessDetail(row.item)"
					:selected="row.item.machine != null ? row.item.machine.code : ''" @input="getMachines"
					:loading="isMachineComboLoading" :isEditable="false" :nolabel="true" />
			</template>
			<template v-slot:cell(subProcess)="row">
				<app-input-combobox-autocomplete :options="subprocesss" optionsLabel="code" optionsKey="id"
					:id="'input-bill-of-process-detail-sub-process-' + row.index" label-cols-lg="12" label="Sub Process"
					size="sm" :model.sync="row.item.subProcessId" @change="saveInputBillOfProcessDetail(row.item)"
					:selected="row.item.subProcess != null ? row.item.subProcess.code : ''" @input="getSubprocesss"
					:loading="isSubprocessComboLoading" :isEditable="false" :nolabel="true" />
			</template>
			<template v-slot:cell(diesOrJigNumber)="row">
				<app-label :id="'input-bill-of-process-detail-dies-or-jig-number-' + row.index" label-cols-lg="12" size="sm"
					label="Dies / Jig" :model="row.item.subProcessNumber" />
			</template>
			<template v-slot:cell(subProcessNumber)="row">
				<app-label :id="'input-bill-of-process-detail-sub-process-number-' + row.index" label-cols-lg="12" size="sm"
					label="Sub Process Number" :model="row.item.subProcessNumber" />
			</template>

			<template v-slot:form-add-detail>
				<BillOfProcessDetailInput :openPopup="isShowPopupBillOfProcessDetail" :modelId="billOfProcessDetailId"
					@resetMethod="resetModal" @addButtonMethod="addRowDataBillOfProcessDetail" />
			</template>
			<template v-slot:upload-detail>
				<BillOfProcessDetailUpload :openPopup="isShowPopupUploadBillOfProcessDetail" @resetMethod="resetModal"
					@uploadButtonMethod="uploadDataBillOfProcessDetail" :parentId="modelId" />
			</template>
			<template #row-details="row">
				<b-card>
					<app-input-combobox-autocomplete :options="machines" optionsLabel="code" optionsKey="id"
						:id="'input-bill-of-process-detail-machine-' + row.index" label-cols-lg="12" label="Machine"
						size="sm" :model.sync="row.item.machineId" @change="saveInputBillOfProcessDetail(row.item)"
						:selected="row.item.machine != null ? row.item.machine.code : ''" @input="getMachines"
						:loading="isMachineComboLoading" :isEditable="false" />
					<app-input-combobox-autocomplete :options="subprocesss" optionsLabel="code" optionsKey="id"
						:id="'input-bill-of-process-detail-sub-process-' + row.index" label-cols-lg="12" label="Sub Process"
						size="sm" :model.sync="row.item.subProcessId" @change="saveInputBillOfProcessDetail(row.item)"
						:selected="row.item.subProcess != null ? row.item.subProcess.code : ''" @input="getSubprocesss"
						:loading="isSubprocessComboLoading" :isEditable="false" />
					<app-label :id="'input-bill-of-process-detail-dies-or-jig-number-' + row.index" label-cols-lg="12"
						size="sm" label="Dies / Jig" :model="row.item.subProcessNumber" />
					<app-label :id="'input-bill-of-process-detail-sub-process-number-' + row.index" label-cols-lg="12"
						size="sm" label="Sub Process Number" :model="row.item.subProcessNumber" />
				</b-card>
			</template>

		</app-table-input-popup>
		<!-- END_APP_DETAIL_HEADER -->
		<b-overlay :show="isBusy" no-wrap>
		</b-overlay>
		<template #modal-left-button>
			<b-button @click="editAction()" size="sm" class="float-right" variant="primary">
				Edit Data
			</b-button>
			<!-- <b-button size="sm" class="float-right" @click="toggleIsActive(model.id)" :variant="model.isActive ? 'danger' : 'success'">
				{{ model.isActive ? "Deactivate" : "Activate" }}
			</b-button> -->
		</template>
	</PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import BillOfProcess from '@/models/BillOfProcess/BillOfProcess';
import BillOfProcessList from '@/models/BillOfProcess/BillOfProcessList';
import BillOfProcessFilter from '@/filters/BillOfProcess/BillOfProcessFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppLabel from '@/components/AppLabel';
import AppInputRadio from '@/components/AppInputRadio';
import BillOfProcessPartType from '@/models/BillOfProcessPartType/BillOfProcessPartType';
import BillOfProcessPartTypeFilter from '@/filters/BillOfProcessPartType/BillOfProcessPartTypeFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import NextProcess from '@/models/NextProcess/NextProcess';
import NextProcessFilter from '@/filters/NextProcess/NextProcessFilter';
import BillOfProcessDetail from '@/models/BillOfProcess/BillOfProcessDetail';
import BillOfProcessDetailFilter from '@/filters/BillOfProcess/BillOfProcessDetailFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import Machine from '@/models/Machine/Machine';
import MachineFilter from '@/filters/Machine/MachineFilter';
import Subprocess from '@/models/Subprocess/Subprocess';
import SubprocessFilter from '@/filters/Subprocess/SubprocessFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import BillOfProcessDetailInput from '@/views/BillOfProcess/BillOfProcessDetailInput';
import BillOfProcessDetailUpload from '@/views/BillOfProcess/BillOfProcessDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components: {
		AppLabel,
		AppInputRadio,
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		BillOfProcessDetailInput, BillOfProcessDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins: [validationMixin],
	validations: {
		model: {
			partNumberId: { required },
		},
	},
	data() {
		return {
			errorMessage: {
				partNumberId: { required: "Part Number is Required." },
			},
			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			fieldsBillOfProcessDetail: [
				{ "frontActions": { "class": "th-actions", "label": "" } },
				{ "no": { "class": "th-number d-stack-none" } },
				{ "sequence": { "class": "th-sequence first-child", "label": "Sequence", key: 'sequence', sortable: false } },
				{ "machine": { "class": "th-machine", "label": "Machine", key: 'machine', sortable: false } },
				{ "subProcess": { "class": "th-sub-process last-child", "label": "Sub Process", key: 'subProcess', sortable: false } },
				{ "diesOrJigNumber": { "class": "th-dies-or-jig-number d-stack-none", "label": "Dies / Jig", key: 'diesOrJigNumber', sortable: false } },
				{ "subProcessNumber": { "class": "th-sub-process-number d-stack-none", "label": "Sub Process Number", key: 'subProcessNumber', sortable: false } },
				{ "actions": { "class": "th-actions d-stack-show", "label": "" } }
			],
			busy: false,
			isBusy: false,
			isDataLoading: false,
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelBillOfProcessDetail: {},
			isShowPopupBillOfProcessDetail: false,
			isShowPopupUploadBillOfProcessDetail: false,
			filterBillOfProcess: null,
			currentBillOfProcessPage: 1,
			billOfProcessPageSize: 10,
			sortByBillOfProcess: '',
			sortDescBillOfProcess: '',
			filterBillOfProcessDetail: null,
			currentBillOfProcessDetailPage: 1,
			billOfProcessDetailPageSize: 10,
			sortByBillOfProcessDetail: '',
			sortDescBillOfProcessDetail: '',
			sortingByBillOfProcessDetail: [],
			billOfProcessDetails: [],
			billOfProcessDetailId: '',
			totalBillOfProcessDetailRow: 0,
			isShowBillOfProcessDetailFilter: false,
			isDownloadBillOfProcessDetail: false,
			machines: [],
			subprocesss: [],
			billOfProcessPartTypes: [],
			billOfProcessPartTypes: [],
			isBillOfProcessPartTypeComboLoading: false,
			parts: [],
			partNumbers: [],
			isPartNumberComboLoading: false,
			nextProcesss: [],
			nextProcesss: [],
			isNextProcessComboLoading: false,
			isShowPopupConfirmation: false,
			isDataCommited: false,
			mainRecordId: '',
			isBillOfProcessPartTypeComboLoading: false,
			isPartComboLoading: false,
			isNextProcessComboLoading: false,
			isBillOfProcessComboLoading: false,
			isMachineComboLoading: false,
			isSubprocessComboLoading: false,
			partSeparate: '',
			partNameSeparate: '',
			messageWorkOrderProcessDetail:false,
		}
	},
	methods: {
		toggleIsActive: async function(id) {
			this.isBusy = true;
			try {
				const response = await this.$http.post(`BillOfProcess/toggleIsActive/${id}`);
				if(response) {
					await this.getBillOfProcess(id);
					this.isBusy = false;
				}
			} catch(error) {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			} finally {
				this.isBusy = false;
			}
		},
		async editAction(modelEvent) {
			let id = this.modelId;
			this.isBusy = true;
			var tot = await this.GetWorkOrderProcessDetail(id);
			// this.messageWorkOrderProcessDetail = true;
			if (id != '' && id != null && id != undefined) {
				if (tot != "") {
					// console.log("this.messageWorkOrderProcessDetail if", this.messageWorkOrderProcessDetail);
					this.$store.dispatch('addErrorMessageGlobal', "Bill Of Process tidak boleh diedit karena sudah digunakan pada transaksi Work Order Process");
					this.isBusy = false;
				} else {
					// console.log("this.messageWorkOrderProcessDetail else", this.messageWorkOrderProcessDetail);
					BillOfProcess.editRequest(this, id).then(result => {
						if (result != null) {
							if (result.id != null && result.id != "") {
								this.$router.push({ name: 'billofprocessedit', params: { id: result.id } });
								this.isBusy = false;
							}
						}
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
				this.messageWorkOrderProcessDetail = false
			}
			// BillOfProcess.createData(this).then(result => {
			// 	if (result != null) {
			// 		if (result.id != null && result.id != "") {
			// 			let createRoute = 'billofprocessedit';
			// 			if(this.isScannerMode) {
			// 				createRoute = 'billofprocessscan';
			// 			}

			// 			this.$router.push({ name: createRoute, params : { id: result.id } });
			// 		}
			// 	}
			// 	this.isBusy = false;
			// }).catch(error => {
			// 	this.isBusy = false;
			// })
			// let id = this.modelId;
			// if(id != '' && id != null && id != undefined) {
			// 	this.$router.push({ name: 'partpricecreate', params : { id: id } });
			// }
		},
		getPartReference: async function () {
			if (!this.model.partNumberId || !this.model.partNumber.partReferenceId) {
				this.partSeparate = '';
				this.partNameSeparate = '';
			} else {
				await Part.getData(this, this.model.partNumber.partReferenceId).then(result => {
					this.partSeparate = result.partNumber;
					this.partNameSeparate = result.partName;
				}).catch(error => { });
			}
		},
		getBillOfProcess: async function (id) {
			this.isBusy = true;
			BillOfProcess.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				if (this.model.partNumberId != null) {
					promises.push(
						this.getPart(this.model.partNumberId).then(result => {
							this.getPartReference();
							return true;
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadBillOfProcess = true;
			this.filterBillOfProcess.id = this.modelId;
			BillOfProcess.downloadDataDetail(this, this.filterBillOfProcess).then(result => {
				this.isDownloadBillOfProcess = false;
			}).catch(error => { this.isDownloadBillOfProcess = false; })
		},
		getBillOfProcessDetails: async function (isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterBillOfProcessDetail);
			if (this.modelId == null) return;
			filter.billOfProcessId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByBillOfProcessDetail != null) {
				this.sortingByBillOfProcessDetail[this.sortByBillOfProcessDetail] = this.sortDescBillOfProcessDetail;
			}
			let currentPage = (this.currentBillOfProcessDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalBillOfProcessDetailRow + 1;
				let page = Math.ceil(totalData / this.billOfProcessDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.billOfProcessDetailPageSize = 0;
			// disable paging end
			BillOfProcessDetail.getList(this, filter, this.sortingByBillOfProcessDetail, currentPage, this.billOfProcessDetailPageSize).then(result => {
				this.currentBillOfProcessDetailPage = currentPage + 1;
				this.billOfProcessDetails = result.data;
				this.totalBillOfProcessDetailRow = result.dataCount;
			}).catch(error => { });
		},
		getBillOfProcesss: async function (input) {
			let filter = new BillOfProcessFilter();
			if (input != undefined) {
				filter.PartNumber = input;
			}
			this.isBillOfProcessComboLoading = true;
			BillOfProcess.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.billOfProcesss = result.data
					}
					this.isBillOfProcessComboLoading = false;
				})
				.catch(error => { });
		},
		getBillOfProcesss: async function (input) {
			let filter = new BillOfProcessFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isBillOfProcessComboLoading = true;
			BillOfProcess.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.billOfProcesss = result.data
					}
					this.isBillOfProcessComboLoading = false;
				})
				.catch(error => { });
		},
		getMachines: async function (input) {
			let filter = new MachineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			this.isMachineComboLoading = true;
			Machine.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.machines = result.data
					}
					this.isMachineComboLoading = false;
				})
				.catch(error => { });
		},
		getSubprocesss: async function (input) {
			let filter = new SubprocessFilter();
			if (input != undefined) {
				filter.code = input;
			}
			this.isSubprocessComboLoading = true;
			Subprocess.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.subprocesss = result.data
					}
					this.isSubprocessComboLoading = false;
				})
				.catch(error => { });
		},
		getBillOfProcessPartTypes: async function (input) {
			let filter = new BillOfProcessPartTypeFilter();
			if (input != undefined) {
				filter.code = input;
			}
			BillOfProcessPartType.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.billOfProcessPartTypes = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedBillOfProcessPartType(item) {
			if (item == undefined || item == null) {
				this.model.billOfProcessPartTypeId = null;
				this.model.billOfProcessPartType = null;
			} else {
				this.model.billOfProcessPartTypeId = item.id;
				this.model.billOfProcessPartType = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getParts: async function (input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.parts = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedPartNumber(item) {
			if (item == undefined || item == null) {
				this.model.partNumberId = null;
				this.model.partNumber = null;
			} else {
				this.model.partNumberId = item.id;
				this.model.partNumber = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getNextProcesss: async function (input) {
			let filter = new NextProcessFilter();
			if (input != undefined) {
				filter.name = input;
			}
			NextProcess.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.nextProcesss = result.data
					}
				})
				.catch(error => { });
		},
		async GetWorkOrderProcessDetail(billOfProcessId){
			return await BillOfProcess.GetWorkOrderProcessDetail(this, billOfProcessId);
		},
		setSelectedNextProcess(item) {
			if (item == undefined || item == null) {
				this.model.nextProcessId = null;
				this.model.nextProcess = null;
			} else {
				this.model.nextProcessId = item.id;
				this.model.nextProcess = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getPart: async function (id) {
			Part.getData(this, id).then(result => {
				this.model.partNumber = result;
				this.isBusy = false;
				return result;
			}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.billOfProcessInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch();
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					BillOfProcess.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'billofprocessindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					BillOfProcess.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'billofprocessindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					BillOfProcess.updateDataDetail(this, model, id)
						.catch((error) => {
							this.getBillOfProcess(id);
						});
				}
			});
		},
		onHidden() {
			this.getBillOfProcesss();
		},
		addRowDataBillOfProcessDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.billOfProcessId = this.modelId;
					BillOfProcessDetail.updateDataDetail(this, model, model.id)
						.then(result => {
							this.getBillOfProcessDetails(true);
							this.isShowPopupBillOfProcessDetail = false;
						})
				} else {
					model.billOfProcessId = this.modelId;
					BillOfProcessDetail.createDataDetail(this, model)
						.then(result => {
							this.getBillOfProcessDetails(true);
							this.isShowPopupBillOfProcessDetail = false;
						})
				}
			}
		},
		async editRowDataBillOfProcessDetail(id) {
			this.billOfProcessDetailId = id;
			this.isShowPopupBillOfProcessDetail = true;
		},
		async deleteRowDataBillOfProcessDetail(id) {
			BillOfProcessDetail.deleteData(this, id).then(result => { this.getBillOfProcessDetails(); });
		},
		async resetDataBillOfProcessDetail() {
			this.billOfProcessDetailId = "";
			this.isShowPopupBillOfProcessDetail = true;
		},
		async addDataBillOfProcessDetail() {
			BillOfProcessDetail.createData(this, { billOfProcessId: this.modelId })
				.then(result => {
					this.getBillOfProcessDetails(true);
				})
		},
		async addFromClipboardBillOfProcessDetail() {
			let sequences = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					sequences.push({ sequence: item, billOfProcessId: this.modelId });
				});
				BillOfProcessDetail.addFromClipboard(this, sequences).then(result => { this.getBillOfProcessDetails() });
			});
		},
		async replaceFromClipboardBillOfProcessDetail() {
			let sequences = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					sequences.push({ sequence: item, billOfProcessId: this.modelId });
				});
				BillOfProcessDetail.replaceFromClipboard(this, sequences).then(result => { this.getBillOfProcessDetails() });
			});
		},
		showPopupUploadBillOfProcessDetail() {
			this.isShowPopupUploadBillOfProcessDetail = true;
		},
		uploadDataBillOfProcessDetail(modalEvent, newDatas) {
			this.isShowPopupUploadBillOfProcessDetail = false;
		},
		downloadBillOfProcessDetail(modalEvent) {
			this.isDownloadBillOfProcessDetail = true;
			this.filterBillOfProcessDetail.billOfProcessId = this.modelId;
			BillOfProcessDetail.downloadDataDetail(this, this.filterBillOfProcessDetail).then(result => {
				this.isDownloadBillOfProcessDetail = false;
			}).catch(error => { this.isDownloadBillOfProcessDetail = false; })
		},
		saveInputBillOfProcessDetail(item) {
			if (this.billOfProcesss != null && this.billOfProcesss != undefined && this.billOfProcesss.length > 0) {
				item.billOfProcess = this.billOfProcesss.find(q => q.id == item.billOfProcessId);
			}
			if (this.machines != null && this.machines != undefined && this.machines.length > 0) {
				item.machine = this.machines.find(q => q.id == item.machineId);
			}
			if (this.subprocesss != null && this.subprocesss != undefined && this.subprocesss.length > 0) {
				item.subProcess = this.subprocesss.find(q => q.id == item.subProcessId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					BillOfProcessDetail.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadBillOfProcessDetail = false;
			this.isShowPopupBillOfProcessDetail = false;
			if (modalType == 'BillOfProcessDetail') {
				this.getBillOfProcessDetails();
			}
			this.showPopupCopyData = false;
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				//this.isShowBillOfProcessDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterBillOfProcess = new BillOfProcessFilter();
		this.filterBillOfProcessDetail = new BillOfProcessDetailFilter();
		//this.getBillOfProcesss();
		//this.getMachines();
		//this.getSubprocesss();
		this.getBillOfProcessPartTypes();
		//this.getParts();
		//this.getNextProcesss();
	},
	async mounted() {
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getBillOfProcess(id);
			} else {
				this.modelId = id;
				this.getBillOfProcess(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function () {
				if (this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch: {
		sortByBillOfProcessDetail: {
			handler: function () {
				this.getBillOfProcessDetails();
			}
		},
		sortDescBillOfProcessDetail: {
			handler: function () {
				this.getBillOfProcessDetails();
			}
		},
		currentBillOfProcessDetailPage: {
			handler: function () {
				this.getBillOfProcessDetails();
			}
		},
		billOfProcessDetailPageSize: {
			handler: function () {
				this.getBillOfProcessDetails();
			}
		},
		filterBillOfProcessDetail: {
			handler: function () {
				this.getBillOfProcessDetails();
			},
			deep: true,
		},
	},
}
</script>
